import { render } from "./SidebarItem.vue?vue&type=template&id=fcc3c004&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=fcc3c004&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=fcc3c004&lang=scss"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc3c004"]])

export default __exports__